import type { apiTypes } from '@cmg/common';
import { apiUtil, loggerUtil } from '@cmg/common';
import type { AxiosError } from 'axios';
import { useCallback, useState } from 'react';

import systemManagementApiClient, {
  type CreateImpersonationSessionRequest,
} from '../../../../../../common/api/systemManagementApiClient';

export const useCreateImpersonationSession = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<apiTypes.GenericServerError | null>(null);

  const reset = useCallback(() => setError(null), []);

  const createSession = useCallback(
    async (request: CreateImpersonationSessionRequest): Promise<string | null> => {
      setIsLoading(true);
      setError(null);

      try {
        const response = await systemManagementApiClient.admin.createImpersonationSession({
          ...request,
          ticket: request.ticket.trim(),
        });

        if (response.ok) {
          return response.data.url;
        }

        loggerUtil.warning('Impersonation session failure', {
          app: request.app,
          targetTenantSubdomain: request.targetTenantSubdomain,
          targetUserId: request.targetUserId,
        });
        setError(response.data.error);
        return null;
      } catch (apiError) {
        const response = apiUtil.transformFailureResponse(
          apiError as AxiosError<apiTypes.GenericResponseDataFailure>
        );
        setError(response.data.error);
        return null;
      } finally {
        setIsLoading(false);
      }
    },
    []
  );

  return {
    createSession,
    error,
    isLoading,
    reset,
  };
};
